<div class="main-container">
  <div class="d-flex justify-content-between px-1">
    <ion-button *ngIf="!hideWhatsappOption" class="whatsapp-btn" size="small" (click)="routeToPath('whatsApp')">
      <ion-icon name="logo-whatsapp" slot="icon-only"></ion-icon>
    </ion-button>

    <ion-button class="email-btn" size="small" (click)="routeToPath('email')">
      <ion-icon name="mail-outline" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</div>